import { Component, Injector, Input, OnInit } from '@angular/core';
import { BillingPaymentListData } from '../billing-payment-list-data';
import { BillingPaymentModel } from '../billing-payment.model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { IBillingModuleModel } from '@fi-app/billing/billing-header/billing-header.component';

@Component({
    selector: 'fi-billing-payment-list',
    template: `<fi-items-list [settings]="ListData"></fi-items-list>`,
    styleUrls: ['./billing-payment-list.component.scss'],
    standalone: false,
})
export class BillingPaymentListComponent
    extends ItemsListContainerBase<ListData<BillingPaymentModel>>
    implements OnInit
{
    @Input() billingModuleModel: IBillingModuleModel;

    constructor(
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private injector: Injector,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new BillingPaymentListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        setTimeout(() => (this.billingModuleModel.ListData = this.ListData));
    }

    protected LoadItems(): Promise<void> {
        return this.fiLoadingService.trackPromise(
            this.billingService.GetPaymentInformation().then((items) => {
                this.ListData.appendData(items);
            }),
        );
    }
}
